<template>
    <div class="d-flex justify-content-center">
        <div class="login-form-1 mt-5">
            <b-card tag="article" style="max-width: 50rem;">
                <div class="card-image">
                    <b-row>
                        <b-col cols="12" md="12">
                            <b-img
                                src="images/shatter-logo.png"
                                fluid
                                alt="Responsive image"
                            />
                        </b-col>
                    </b-row>
                </div>
                <div class="card-text">
                    <b-row>
                        <b-col cols="12" md="12">
                            <hr />
                            <app-assigned-client-list
                                :clients="assignedClients"
                            />
                        </b-col>
                        <!-- <b-col cols="12" md="12">
                            <hr>
                            <app-other-client-list :clients="otherClients" />
                        </b-col> -->
                    </b-row>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import AssignedClientList from './AssignedClientList.vue'
import OtherClientList from './otherClientList.vue'

export default {
    components: {
        appAssignedClientList: AssignedClientList,
        appOtherClientList: OtherClientList,
    },
    props: {
        assignedClients: {
            type: Function,
            default: () => [],
        },
        otherClients: {
            type: Function,
            default: () => [],
        },
    },
    created() {
        this.$store.commit('accessPoint', null)
    },
}
</script>
